export type Fruit = {
  id: string
  emoji: string
  label: string
  color: number
}

export const FRUITS: Fruit[] = [
  { id: 'strawberry', emoji: '🍓', label: '草莓',   color: 0xff4d6a },
  { id: 'orange',     emoji: '🍊', label: '橙子',   color: 0xff9527 },
  { id: 'lemon',      emoji: '🍋', label: '柠檬',   color: 0xffd93d },
  { id: 'kiwi',       emoji: '🥝', label: '猕猴桃', color: 0x8fb14a },
  { id: 'blueberry',  emoji: '🫐', label: '蓝莓',   color: 0x4a5fd8 },
  { id: 'grape',      emoji: '🍇', label: '葡萄',   color: 0xa06ec0 },
]
